import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlPrestacao = '/service/contabilidade/transparencia/convenio/'

class DetalhesPrestacaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultarDetalhes(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlPrestacao + 'detalhesPrestacao/', JSON.stringify(data))
    }

    consultarDocumentosPrestacao(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlPrestacao + 'documentosPrestacao/', JSON.stringify(data))
    }
}

export default DetalhesPrestacaoService
